module.exports = __webpack_public_path__ + "static/media/image_28.782c0c46.png";